
export class DestinationSession {
  destEnvironmentId: string;
  destinationEnvironmentName: string;
  destCorporationId: string;
  destinationCorporationName: string;
  destFacilityId: string;
  destinationFacilityName: string;
}
